import { handleUnauthorizedError } from "@medme/auth/unauthorized-handler"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"

export function getContext() {
	const queryClient = new QueryClient({
		defaultOptions: {
			queries: {
				// Note: The 'onError' property is not valid for queries in React Query's QueryClient defaultOptions.
				// If you need centralized error handling for queries, consider using queryClient.getQueryCache().subscribe or handle errors at query usage sites.
			},
			mutations: {
				onError: (error) => {
					handleUnauthorizedError(error)
				},
			},
		},
	})
	return {
		queryClient,
	}
}

export function Provider({
	children,
	queryClient,
}: {
	children: React.ReactNode
	queryClient: QueryClient
}) {
	return (
		<QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
	)
}
